import {login, logout, getInfo} from '@/api/login'
import {getToken, setToken, removeToken} from '@/utils/auth'
import defAva from '@/assets/logo/logo.png'
import { resolveHomePath } from '@/utils/rundu'

const useUserStore = defineStore(
    'user',
    {
        state: () => ({
            token: getToken(),
            name: '',
            avatar: '',
            nickName: '',
            email: '',
            roles: [],
            permissions: [],
            homePage: sessionStorage.getItem('homePage') || 'index',
        }),
        getters: {
            homePath: (state) => resolveHomePath(state.homePage),
        },
        actions: {
            // 登录
            login(userInfo) {
                const username = userInfo.username.trim()
                const password = userInfo.password
                const code = userInfo.code
                const uuid = userInfo.uuid
                return new Promise((resolve, reject) => {
                    login(username, password, code, uuid).then(res => {
                        let data = res.data
                        setToken(data.access_token)
                        this.token = data.access_token
                        resolve()
                    }).catch(error => {
                        reject(error)
                    })
                })
            },
            // 获取用户信息
            getInfo() {
                return new Promise((resolve, reject) => {
                    getInfo().then(res => {
                        const user = res.user
                        const avatar = (user.avatar == "" || user.avatar == null) ? defAva : user.avatar;

                        if (res.roles && res.roles.length > 0) { // 验证返回的roles是否是一个非空数组
                            this.roles = res.roles
                            this.permissions = res.permissions
                        } else {
                            this.roles = ['ROLE_DEFAULT']
                        }
                        this.nickName = user.nickName;
                        this.email = user.email;
                        this.name = user.userName
                        this.avatar = avatar;
                        const homePage = user.homePage || 'index'
                        this.homePage = homePage
                        sessionStorage.setItem('homePage', homePage)
                        if (user.dept?.deptId != null) {
                            sessionStorage.setItem('userinfo', user.dept.deptId)
                            if (user.dept.deptName) {
                                localStorage.setItem('deptName', user.dept.deptName)
                            }
                        }
                        resolve(res)
                    }).catch(error => {
                        reject(error)
                    })
                })
            },
            // 退出系统
            logOut() {
                return new Promise((resolve, reject) => {
                    logout(this.token).then(() => {
                        this.token = ''
                        this.roles = []
                        this.permissions = []
                        this.homePage = 'index'
                        sessionStorage.removeItem('homePage')
                        removeToken()
                        resolve()
                    }).catch(error => {
                        reject(error)
                    })
                })
            }
        }
    })

export default useUserStore
